export default __webpack_public_path__ + "static/media/800x600.5c02102f.png";